import CalculatorStandardInput from '../../../../calculatorInputs/CalculatorStandardInput';
import i18next from 'i18next';
import React from 'react';

const ContainsValue = ({ fieldName, showLabel, readOnly = false }) => {
  const label = showLabel
    ? i18next.t('calculator.dialog.create.label.values')
    : '';
  const placeholder = i18next.t(
    `calculator.dialog.create.placeholder.selectValues`
  );
  return (
    <CalculatorStandardInput
      fieldName={`${fieldName}.${0}`}
      isRequired
      uxVariant="criteriaInput"
      variant="standard"
      label={label}
      placeholder={placeholder}
      validate={() => null}
      triggerOnContinue
      disabled={readOnly}
    />
  );
};

export default ContainsValue;
